import React from 'react';
import { string } from 'prop-types';
import { getThemeObj, toKey } from '@/helpers';
import Overview from './Overview';
import Js from './Js';
import HtmlCss from './HtmlCss';
import Cms from './Cms';
import Design from './Design';
import Workflow from './Workflow';
import DataVisualization from './DataVisualization';
import Testing from './Testing';
import Performance from './Performance';
import { SThemeTitle, SThemeDetails } from './styles';

const ThemeDetails = ({ theme = 'overview' }) => {
  const themeMap = {
    overview: <Overview />,
    js: <Js />,
    cms: <Cms />,
    design: <Design />,
    htmlcss: <HtmlCss />,
    workflow: <Workflow />,
    dataviz: <DataVisualization />,
    testing: <Testing />,
    performance: <Performance />,
  };

  const themeColor = getThemeObj(theme).color;
  const themeTitle = getThemeObj(theme).title;

  return (
    <SThemeDetails>
      <SThemeTitle
        data-testid={`theme-${toKey(themeTitle)}`}
        color={themeColor}
      >
        {themeTitle}
      </SThemeTitle>
      {themeMap[theme]}
    </SThemeDetails>
  );
};

ThemeDetails.propTypes = {
  theme: string.isRequired,
};

export default ThemeDetails;
